import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import lightLogo from "../assets/DataOpsLogo.png"
import darkLogo from "../assets/DataOpsLogo_dark.png"
import { appRoutes } from '../routes';

interface HeaderProps {
  showAbout: boolean;
  onToggleAbout: () => void;
}

export default function Header({ showAbout, onToggleAbout }: HeaderProps) {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const [logo, setLogo] = useState<typeof lightLogo | typeof darkLogo>(lightLogo);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) return;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 50) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);

    const savedLogo = localStorage.getItem('logo') === darkLogo ? darkLogo : lightLogo;
    setLogo(savedLogo);
    document.documentElement.setAttribute('logo-theme', savedLogo);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    const newLogo = theme === 'light' ? darkLogo : lightLogo;
    setLogo(newLogo)
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    document.documentElement.setAttribute('logo-theme', newLogo);
    localStorage.setItem('theme', newTheme);
    localStorage.setItem('logo', newLogo);
  };

  return (
    <header className={`header ${!isVisible ? 'header-hidden' : ''}`}>
      <div className="header-container">
        <div className="header-top">

          <div className="logo-container">
            <img src={logo} alt="Logo" className="logo" />
          </div>
          
          {/* <div className="logo-section">
            <div>
              <span className="header-text">DataOps</span>
            </div>
          </div> */}

          <div className="header-controls">
            <button
              className="icon-button"
              onClick={onToggleAbout}
              title="About"
            >
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>

            <button
              className="icon-button"
              onClick={toggleTheme}
              title="Toggle theme"
            >
              {theme === 'light' ? (
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              ) : (
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <nav className="tab-nav">
          {appRoutes.map(route => (
            <NavLink
              key={route.path}
              to={route.path}
              end
              className={({ isActive }) => `tab-button ${isActive ? 'active' : ''}`}
            >
              {route.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}